module.exports = __webpack_public_path__ + "static/img/img_gy_e_a.39674945.png";